var form = document.getElementById("loops-subscribe-form");

function handleForm(event) {
  event.preventDefault();
  const formBody = `email=${document.getElementById("loops-EMAIL").value}`;
  fetch("https://app.loops.so/api/newsletter-form/clt224nid01ho5vunae86by2q", {
    method: "POST",
    body: formBody,
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
  })
    .then((response) => response.json())
    .then((response) => {
      // console.log("RESPONSE: ", response);
      if (response.success) {
        // console.log("SUCCESS");
        document.getElementById("success-message").style.display = "block";
        document.getElementById("loops-subscribe-form").style.display = "none";
        document.getElementById("form-title").style.display = "none";
      }
    })
    .catch((err) => console.error(err));
}

form.addEventListener("submit", handleForm);
